<script>
  import { format } from 'svelte-i18n';
  import { Progress } from '@sveltestrap/sveltestrap';

  export let current = 0;
  export let total = undefined;
  export let type = 'USERS';

  $: indeterminate = !total;
</script>

{#if indeterminate}
  <Progress animated striped value={100} />
  <p class="p-3 text-center">
    {$format(`label.SYNC_PROGRESS_INDETERMINATE_${type}`, {
      values: { n: current }
    })}
  </p>
{:else}
  <Progress value={Math.ceil((current / total) * 100)} />
  <p class="p-3 text-center">
    {$format(`label.SYNC_PROGRESS_${type}`, {
      values: { n: current, total }
    })}
  </p>
{/if}
